export enum FeatureOwners {
  BAHAMAS = 'Bahamas',
  KOS = 'Kos',
  KYOTO = 'Kyoto',
  RIO = 'Rio',
  MAUI = 'Maui',
}

export const featureOwnersColors: Record<FeatureOwners, string> = {
  [FeatureOwners.BAHAMAS]: '#2a9d8f',
  [FeatureOwners.KOS]: '#e9c46a',
  [FeatureOwners.KYOTO]: '#c1121f',
  [FeatureOwners.RIO]: '#bfff00',
  [FeatureOwners.MAUI]: '#24fa17',
};
